import '@/styles/main.scss'

import Vue from 'vue'
import App from './App.vue'
import Store from '@/stores/store.js'

import { ObserveVisibility } from 'vue-observe-visibility'
require('./utils/modernizr-custom.js')

import router from './router'
import myMoment from "moment";
import VueMomentLib from "vue-moment-lib";
import UAParser from "ua-parser-js";
import smoothscroll from 'smoothscroll-polyfill';
import 'intersection-observer'

smoothscroll.polyfill();

Vue.config.productionTip = false
Vue.directive('observe-visibility', ObserveVisibility)


myMoment.updateLocale('en', {
    monthsShort: [ "jan", "feb", "mar", "apr", "may", "jun", "jul.", "aug", "sept", "oct", "nov", "dec" ]
});

Vue.use(VueMomentLib, { moment: myMoment });


Store.state.changeBrowser = false;


/**
 * WARNING !!!!
 * 
 * There is problem on the ray intersection calculcation with scale. To solve it we need to comment the following condition in the three package
 *  ```
        //t < 0, no intersection
        if ( QdN < 0 ) {
    ```
 */

//Add the pivot capabilities to threejs
THREE.Object3D.prototype.updateMatrix = function () {

    this.matrix.compose(this.position, this.quaternion, this.scale);

    var pivot = this.pivot;

    if (pivot !== undefined) {
        var px = pivot.x, py = pivot.y, pz = pivot.z;
        var te = this.matrix.elements;

        te[12] += px - te[0] * px - te[4] * py - te[8] * pz;
        te[13] += py - te[1] * px - te[5] * py - te[9] * pz;
        te[14] += pz - te[2] * px - te[6] * py - te[10] * pz;

    }

    this.matrixWorldNeedsUpdate = true;

};

// injection d'une fonction pour l'option personnalisée `myOption`
Vue.mixin({
    methods: {
        vw: function (val) {
            return Store.width / 100 * val;
        },
    }
})
new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
